import React from "react"

import { Box } from "../Box/Box"
import { text } from "./Text.css"
import type { TextVariantProps } from "./types"
import type { BoxProps, TextElements } from "../Box/Box"

export type TextProps<AS extends TextElements = "p"> = BoxProps<AS> &
  TextVariantProps

export function Text<As extends TextElements>(
  props: TextProps<As>
): JSX.Element {
  const {
    children,
    as = "p",
    className,
    variant,
    bold,
    semiBold,
    strikeThrough,
    underline,
    color,
    font,
    ...rest
  } = props

  const variantClassName = text({
    variant,
    bold,
    semiBold,
    strikeThrough,
    underline,
    color,
    font,
  })
  const boxProps = rest as BoxProps<As>

  return (
    <Box {...boxProps} as={as} className={[variantClassName, className]}>
      {children}
    </Box>
  )
}
